<template>
  <div class="navbar-responsive">
    <button class="navbar-toggler" type="button" @click="openDrawer">
      <span class="navbar-toggler-icon navbar-light"></span>
    </button>

    <el-drawer
      :visible.sync="drawerVisible"
      :direction="direction"
      :modal="true"
      :append-to-body="true"
      custom-class="nav-drawer-clean"
    >
      <template slot="title">
        <LogoComponent width="42" color="blue" class="drawer-logo" />
      </template>
      <NavbarItemsComponent
        @onClickNavbarItems="closeDrawer"
        classNames="mobile-clean"
      />
    </el-drawer>
  </div>
</template>

<script>
import NavbarItemsComponent from "./NavbarItems";
import LogoComponent from "@/components/Logo/Logo";

export default {
  name: "NavbarResponsiveComponent",
  data() {
    return {
      drawerVisible: false,
      direction: "ltr"
    };
  },
  methods: {
    openDrawer() {
      this.drawerVisible = true;
    },
    closeDrawer() {
      this.drawerVisible = false;
      this.cleanupOverlay();
    },
    cleanupOverlay() {
      setTimeout(() => {
        // Si hay algún dialog/drawer visible, no tocar el overlay
        const hasOpenPopup = Array.from(
          document.querySelectorAll(".el-dialog__wrapper")
        ).some(el => el.style.display !== "none");
        if (hasOpenPopup) return;

        document.querySelectorAll(".v-modal").forEach(el => {
          el.parentNode && el.parentNode.removeChild(el);
        });
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
        document.body.classList.remove("el-popup-parent--hidden");
      }, 300);
    }
  },
  watch: {
    $route() {
      if (this.drawerVisible) {
        this.closeDrawer();
      }
    },
    drawerVisible(val) {
      if (!val) {
        this.cleanupOverlay();
      }
    }
  },
  components: {
    NavbarItemsComponent,
    LogoComponent
  }
};
</script>

<style>
/* Drawer con fondo blanco y texto oscuro */
.nav-drawer-clean {
  background: #fff !important;
}
.nav-drawer-clean .el-drawer__header {
  background: #fff !important;
  border-bottom: 1px solid #e4eaf6;
  padding: 14px 16px !important;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: auto;
}
.nav-drawer-clean .el-drawer__title {
  flex: none;
}
.nav-drawer-clean .el-drawer__body {
  padding: 0;
}
/* Botón close del drawer nav — sin fondo, borde gris */
.nav-drawer-clean .el-drawer__close-btn {
  width: 32px !important;
  height: 32px !important;
  background: transparent !important;
  border: 1px solid #e4eaf6 !important;
  border-radius: 8px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: 0 !important;
  position: static !important;
  transition: all 0.15s;

  &:hover {
    border-color: #c0c4cc !important;
    background: #f7f8f9 !important;
  }

  .el-dialog__close {
    color: #909399 !important;
    font-size: 14px;
  }
}

/* Links del menu en modo clean */
.mobile-clean {
  list-style: none;
  padding: 12px 0;
  margin: 0;
}
.mobile-clean .nav-item {
  margin: 0 !important;
}
.mobile-clean .nav-item a {
  display: block;
  padding: 14px 24px !important;
  color: #606266 !important;
  font-size: 15px !important;
  font-weight: 500 !important;
  text-align: center !important;
  text-decoration: none;
  transition: all 0.15s;
}
.mobile-clean .nav-item a:hover {
  background: #f7f8f9;
  color: #31355c !important;
}
.mobile-clean .nav-item a.menu-link-active {
  color: #3fdbbf !important;
  font-weight: 600 !important;
  background: #f0fdf9;
  border-left-color: #3fdbbf;
}

/* Fix drawer logo size */
.drawer-logo {
  width: 42px !important;
  height: 42px !important;
  max-width: 42px !important;
  display: block;
  border-radius: 10px;
  object-fit: contain;
  padding: 4px;
}
</style>
